import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import createRouter from '@/router'
import { createAnalytics, analyticsPlugin } from '@/analytics'
import Buefy, { buefyOptions } from '@/buefy'
import '@/styles/root.scss'
import Rails from '@rails/ujs'

Rails.start()

// Eagerly load all images from the assets directory
import.meta.glob('../src/assets/**/*.{png,jpg,gif,ico,svg}')

document.addEventListener('DOMContentLoaded', () => {
  const appEl = document.getElementById('app')
  if (appEl) {
    const router = createRouter()
    const pinia = createPinia()
    const analytics = createAnalytics()

    createApp(App)
      .use(router)
      .use(pinia)
      .use(Buefy, buefyOptions)
      .use(analyticsPlugin, analytics)
      .mount(appEl)
  }
})
